export const noIndexPages = [
  "/atp/line-movement/ats-odds",
  "/atp/line-movement/over-unders",
  "/atp/public-betting/ats-odds",
  "/atp/public-betting/over-unders",
  "/atp/sharp-picks/ats-odds",
  "/atp/sharp-picks/over-unders",
  "/bundesliga/line-movement/first-half-lines",
  "/bundesliga/line-movement/first-half-moneyline",
  "/bundesliga/line-movement/over-unders",
  "/bundesliga/line-movement/second-half-line",
  "/bundesliga/line-movement/second-half-moneyline",
  "/bundesliga/line-movement/spread",
  "/bundesliga/odds/first-half-lines",
  "/bundesliga/odds/first-half-moneyline",
  "/bundesliga/odds/second-half-line",
  "/bundesliga/odds/second-half-moneyline",
  "/bundesliga/public-betting/first-half-lines",
  "/bundesliga/public-betting/first-half-moneyline",
  "/bundesliga/public-betting/over-unders",
  "/bundesliga/public-betting/second-half-line",
  "/bundesliga/public-betting/second-half-moneyline",
  "/bundesliga/public-betting/spread",
  "/bundesliga/sharp-picks/first-half-lines",
  "/bundesliga/sharp-picks/first-half-moneyline",
  "/bundesliga/sharp-picks/over-unders",
  "/bundesliga/sharp-picks/second-half-line",
  "/bundesliga/sharp-picks/second-half-moneyline",
  "/bundesliga/sharp-picks/spread",
  "/champions-league/line-movement/first-half-lines",
  "/champions-league/line-movement/first-half-moneyline",
  "/champions-league/line-movement/over-unders",
  "/champions-league/line-movement/second-half-line",
  "/champions-league/line-movement/second-half-moneyline",
  "/champions-league/line-movement/spread",
  "/champions-league/odds/first-half-lines",
  "/champions-league/odds/first-half-moneyline",
  "/champions-league/odds/over-unders",
  "/champions-league/odds/second-half-line",
  "/champions-league/odds/second-half-moneyline",
  "/champions-league/odds/spread",
  "/champions-league/public-betting/first-half-lines",
  "/champions-league/public-betting/first-half-moneyline",
  "/champions-league/public-betting/over-unders",
  "/champions-league/public-betting/second-half-line",
  "/champions-league/public-betting/second-half-moneyline",
  "/champions-league/public-betting/spread",
  "/champions-league/sharp-picks/first-half-lines",
  "/champions-league/sharp-picks/first-half-moneyline",
  "/champions-league/sharp-picks/over-unders",
  "/champions-league/sharp-picks/second-half-line",
  "/champions-league/sharp-picks/second-half-moneyline",
  "/champions-league/sharp-picks/spread",
  "/la-liga/line-movement/first-half-lines",
  "/la-liga/line-movement/first-half-moneyline",
  "/la-liga/line-movement/over-unders",
  "/la-liga/line-movement/second-half-line",
  "/la-liga/line-movement/second-half-moneyline",
  "/la-liga/line-movement/spread",
  "/la-liga/odds/first-half-lines",
  "/la-liga/odds/first-half-moneyline",
  "/la-liga/odds/over-unders",
  "/la-liga/odds/second-half-line",
  "/la-liga/odds/second-half-moneyline",
  "/la-liga/public-betting/first-half-lines",
  "/la-liga/public-betting/first-half-moneyline",
  "/la-liga/public-betting/over-unders",
  "/la-liga/public-betting/second-half-line",
  "/la-liga/public-betting/second-half-moneyline",
  "/la-liga/public-betting/spread",
  "/la-liga/sharp-picks/first-half-lines",
  "/la-liga/sharp-picks/first-half-moneyline",
  "/la-liga/sharp-picks/over-unders",
  "/la-liga/sharp-picks/second-half-line",
  "/la-liga/sharp-picks/second-half-moneyline",
  "/la-liga/sharp-picks/spread",
  "/mlb/line-movement/first-five-innings-odds",
  "/mlb/line-movement/first-five-innings-totals",
  "/mlb/line-movement/run-line-odds",
  "/mlb/line-movement/totals-spread",
  "/mlb/odds/moneyline",
  "/mlb/public-betting/first-five-innings-odds",
  "/mlb/public-betting/first-five-innings-totals",
  "/mlb/public-betting/run-line-odds",
  "/mlb/public-betting/totals-spread",
  "/mlb/sharp-picks/first-five-innings-odds",
  "/mlb/sharp-picks/first-five-innings-totals",
  "/mlb/sharp-picks/run-line-odds",
  "/mlb/sharp-picks/totals-spread",
  "/mls/line-movement/first-half-lines",
  "/mls/line-movement/first-half-moneyline",
  "/mls/line-movement/over-unders",
  "/mls/line-movement/second-half-line",
  "/mls/line-movement/second-half-moneyline",
  "/mls/line-movement/spread",
  "/mls/odds/first-half-lines",
  "/mls/odds/first-half-moneyline",
  "/mls/odds/second-half-line",
  "/mls/odds/second-half-moneyline",
  "/mls/public-betting/first-half-lines",
  "/mls/public-betting/first-half-moneyline",
  "/mls/public-betting/over-unders",
  "/mls/public-betting/second-half-line",
  "/mls/public-betting/second-half-moneyline",
  "/mls/public-betting/spread",
  "/mls/sharp-picks/first-half-lines",
  "/mls/sharp-picks/first-half-moneyline",
  "/mls/sharp-picks/over-unders",
  "/mls/sharp-picks/second-half-line",
  "/mls/sharp-picks/second-half-moneyline",
  "/mls/sharp-picks/spread",
  "/nba/line-movement/first-half-lines",
  "/nba/line-movement/first-half-moneyline",
  "/nba/line-movement/first-half-totals-spread",
  "/nba/line-movement/moneyline",
  "/nba/line-movement/second-half-lines",
  "/nba/line-movement/second-half-moneylines",
  "/nba/line-movement/totals-spread",
  "/nba/odds/first-half-moneyline",
  "/nba/odds/first-half-totals-spread",
  "/nba/odds/second-half-moneylines",
  "/nba/public-betting/first-half-lines",
  "/nba/public-betting/first-half-moneyline",
  "/nba/public-betting/first-half-totals-spread",
  "/nba/public-betting/moneyline",
  "/nba/public-betting/second-half-lines",
  "/nba/public-betting/second-half-moneylines",
  "/nba/public-betting/totals-spread",
  "/nba/sharp-picks//first-half-moneyline",
  "/nba/sharp-picks/first-half-lines",
  "/nba/sharp-picks/first-half-moneyline",
  "/nba/sharp-picks/first-half-totals-spread",
  "/nba/sharp-picks/moneyline",
  "/nba/sharp-picks/second-half-lines",
  "/nba/sharp-picks/second-half-moneylines",
  "/nba/sharp-picks/totals-spread",
  "/ncaab/line-movement/first-half-lines",
  "/ncaab/line-movement/first-half-lines/america-east",
  "/ncaab/line-movement/first-half-moneyline",
  "/ncaab/line-movement/first-half-totals-spread",
  "/ncaab/line-movement/moneyline",
  "/ncaab/line-movement/second-half-lines",
  "/ncaab/line-movement/second-half-moneylines",
  "/ncaab/line-movement/totals-spread",
  "/ncaab/odds/first-half-moneyline",
  "/ncaab/odds/second-half-moneylines",
  "/ncaab/public-betting/first-half-lines",
  "/ncaab/public-betting/first-half-moneyline",
  "/ncaab/public-betting/first-half-totals-spread",
  "/ncaab/public-betting/moneyline",
  "/ncaab/public-betting/second-half-lines",
  "/ncaab/public-betting/second-half-moneylines",
  "/ncaab/public-betting/totals-spread",
  "/ncaab/sharp-picks/first-half-moneyline",
  "/ncaab/sharp-picks/first-half-totals-spread",
  "/ncaab/sharp-picks/moneyline",
  "/ncaab/sharp-picks/second-half-lines",
  "/ncaab/sharp-picks/second-half-moneylines",
  "/ncaab/sharp-picks/totals-spread",
  "/ncaaf/line-movement/first-half-lines",
  "/ncaaf/line-movement/first-half-moneyline",
  "/ncaaf/line-movement/first-half-totals-spread",
  "/ncaaf/line-movement/moneyline",
  "/ncaaf/line-movement/second-half-lines",
  "/ncaaf/line-movement/second-half-moneylines",
  "/ncaaf/line-movement/totals-spread",
  "/ncaaf/odds/first-half-moneyline",
  "/ncaaf/odds/second-half-moneylines",
  "/ncaaf/public-betting/first-half-lines",
  "/ncaaf/public-betting/first-half-moneyline",
  "/ncaaf/public-betting/first-half-totals-spread",
  "/ncaaf/public-betting/moneyline",
  "/ncaaf/public-betting/second-half-lines",
  "/ncaaf/public-betting/second-half-moneylines",
  "/ncaaf/public-betting/totals-spread",
  "/ncaaf/sharp-picks/first-half-lines",
  "/ncaaf/sharp-picks/first-half-moneyline",
  "/ncaaf/sharp-picks/first-half-totals-spread",
  "/ncaaf/sharp-picks/moneyline",
  "/ncaaf/sharp-picks/moneylinecollege%20football%20moneylines&lt;",
  "/ncaaf/sharp-picks/second-half-lines",
  "/ncaaf/sharp-picks/second-half-moneylines",
  "/ncaaf/sharp-picks/totals-spread",
  "/nfl/line-movement/first-half-lines",
  "/nfl/line-movement/first-half-moneyline",
  "/nfl/line-movement/first-half-totals-spread",
  "/nfl/line-movement/moneyline",
  "/nfl/line-movement/second-half-lines",
  "/nfl/line-movement/second-half-moneylines",
  "/nfl/line-movement/totals-spread",
  "/nfl/odds/first-half-moneyline",
  "/nfl/odds/first-half-totals-spread",
  "/nfl/odds/second-half-moneylines",
  "/nfl/public-betting/first-half-lines",
  "/nfl/public-betting/first-half-moneyline",
  "/nfl/public-betting/first-half-totals-spread",
  "/nfl/public-betting/moneyline",
  "/nfl/public-betting/second-half-lines",
  "/nfl/public-betting/second-half-moneylines",
  "/nfl/public-betting/totals-spread",
  "/nfl/sharp-picks//first-half-moneyline",
  "/nfl/sharp-picks/first-half-lines",
  "/nfl/sharp-picks/first-half-moneyline",
  "/nfl/sharp-picks/first-half-totals-spread",
  "/nfl/sharp-picks/moneyline",
  "/nfl/sharp-picks/second-half-lines",
  "/nfl/sharp-picks/second-half-moneylines",
  "/nfl/sharp-picks/totals-spread",
  "/nhl/line-movement/ats-odds",
  "/nhl/line-movement/first-period-ats-odds",
  "/nhl/line-movement/first-period-moneyline",
  "/nhl/line-movement/first-period-totals-spread",
  "/nhl/line-movement/moneyline",
  "/nhl/line-movement/second-half-lines",
  "/nhl/line-movement/second-period-ats-odds",
  "/nhl/line-movement/second-period-moneyline",
  "/nhl/line-movement/third-period-ats-odds",
  "/nhl/line-movement/third-period-moneyline",
  "/nhl/line-movement/totals-spread",
  "/nhl/line-movement/tsecond-period-ats-odds",
  "/nhl/line-movement/tsecond-period-moneyline",
  "/nhl/odds/first-period-ats-odds",
  "/nhl/odds/first-period-moneyline",
  "/nhl/odds/first-period-totals-spread",
  "/nhl/odds/moneyline",
  "/nhl/odds/second-half-lines",
  "/nhl/odds/second-period-ats-odds",
  "/nhl/odds/second-period-moneyline",
  "/nhl/odds/third-period-ats-odds",
  "/nhl/odds/third-period-moneyline",
  "/nhl/odds/tsecond-period-ats-odds",
  "/nhl/odds/tsecond-period-moneyline",
  "/nhl/public-betting/ats-odds",
  "/nhl/public-betting/first-period-ats-odds",
  "/nhl/public-betting/first-period-moneyline",
  "/nhl/public-betting/first-period-totals-spread",
  "/nhl/public-betting/moneyline",
  "/nhl/public-betting/second-half-lines",
  "/nhl/public-betting/second-period-ats-odds",
  "/nhl/public-betting/second-period-moneyline",
  "/nhl/public-betting/third-period-ats-odds",
  "/nhl/public-betting/third-period-moneyline",
  "/nhl/public-betting/totals-spread",
  "/nhl/public-betting/tsecond-period-ats-odds",
  "/nhl/public-betting/tsecond-period-moneyline",
  "/nhl/sharp-picks/ats-odds",
  "/nhl/sharp-picks/first-period-ats-odds",
  "/nhl/sharp-picks/first-period-moneyline",
  "/nhl/sharp-picks/first-period-totals-spread",
  "/nhl/sharp-picks/moneyline",
  "/nhl/sharp-picks/second-half-lines",
  "/nhl/sharp-picks/second-period-ats-odds",
  "/nhl/sharp-picks/second-period-moneyline",
  "/nhl/sharp-picks/third-period-ats-odds",
  "/nhl/sharp-picks/third-period-moneyline",
  "/nhl/sharp-picks/totals-spread",
  "/nhl/sharp-picks/tsecond-period-ats-odds",
  "/nhl/sharp-picks/tsecond-period-moneyline",
  "/premier-league/line-movement/first-half-lines",
  "/premier-league/line-movement/first-half-moneyline",
  "/premier-league/line-movement/over-unders",
  "/premier-league/line-movement/second-half-line",
  "/premier-league/line-movement/second-half-moneyline",
  "/premier-league/line-movement/spread",
  "/premier-league/odds/first-half-lines",
  "/premier-league/odds/first-half-moneyline",
  "/premier-league/odds/over-unders",
  "/premier-league/odds/second-half-line",
  "/premier-league/odds/second-half-moneyline",
  "/premier-league/odds/spread",
  "/premier-league/public-betting/first-half-lines",
  "/premier-league/public-betting/first-half-moneyline",
  "/premier-league/public-betting/over-unders",
  "/premier-league/public-betting/second-half-line",
  "/premier-league/public-betting/second-half-moneyline",
  "/premier-league/public-betting/spread",
  "/premier-league/sharp-picks/first-half-lines",
  "/premier-league/sharp-picks/first-half-moneyline",
  "/premier-league/sharp-picks/over-unders",
  "/premier-league/sharp-picks/second-half-line",
  "/premier-league/sharp-picks/second-half-moneyline",
  "/premier-league/sharp-picks/spread",
  "/serie-a/line-movement/first-half-lines",
  "/serie-a/line-movement/first-half-moneyline",
  "/serie-a/line-movement/over-unders",
  "/serie-a/line-movement/second-half-line",
  "/serie-a/line-movement/second-half-moneyline",
  "/serie-a/line-movement/spread",
  "/serie-a/odds/first-half-lines",
  "/serie-a/odds/first-half-moneyline",
  "/serie-a/odds/over-unders",
  "/serie-a/odds/second-half-line",
  "/serie-a/odds/second-half-moneyline",
  "/serie-a/public-betting/first-half-lines",
  "/serie-a/public-betting/first-half-moneyline",
  "/serie-a/public-betting/over-unders",
  "/serie-a/public-betting/second-half-line",
  "/serie-a/public-betting/second-half-moneyline",
  "/serie-a/public-betting/spread",
  "/serie-a/sharp-picks/first-half-lines",
  "/serie-a/sharp-picks/first-half-moneyline",
  "/serie-a/sharp-picks/over-unders",
  "/serie-a/sharp-picks/second-half-line",
  "/serie-a/sharp-picks/second-half-moneyline",
  "/serie-a/sharp-picks/spread",
  "/wta/line-movement/ats-odds",
  "/wta/line-movement/over-unders",
  "/wta/public-betting/ats-odds",
  "/wta/public-betting/over-unders",
  "/wta/sharp-picks/ats-odds",
  "/wta/sharp-picks/over-unders",
  "/nba/best-bets/moneyline",
  "/nba/best-bets/totals-spread",
  "/nba/best-bets/first-half-lines",
  "/nba/best-bets/first-half-moneyline",
  "/nba/best-bets/first-half-totals-spread",
  "/nba/best-bets/second-half-lines",
  "/nba/best-bets/second-half-moneylines",
  "/ncaab/best-bets/moneyline",
  "/ncaab/best-bets/moneyline/ncaa-tournament",
  "/ncaab/best-bets/moneyline/nit-tournament",
  "/ncaab/best-bets/moneyline/cbi-tournament",
  "/ncaab/best-bets/moneyline/cit-tournament",
  "/ncaab/best-bets/moneyline/all",
  "/ncaab/best-bets/moneyline/top-25",
  "/ncaab/best-bets/moneyline/america-east",
  "/ncaab/best-bets/moneyline/american",
  "/ncaab/best-bets/moneyline/atlantic-10",
  "/ncaab/best-bets/moneyline/atlantic-coast",
  "/ncaab/best-bets/moneyline/atlantic-sun",
  "/ncaab/best-bets/moneyline/big-12",
  "/ncaab/best-bets/moneyline/big-east",
  "/ncaab/best-bets/moneyline/big-sky",
  "/ncaab/best-bets/moneyline/big-south",
  "/ncaab/best-bets/moneyline/big-ten",
  "/ncaab/best-bets/moneyline/big-west",
  "/ncaab/best-bets/moneyline/colonial",
  "/ncaab/best-bets/moneyline/conference-usa",
  "/ncaab/best-bets/moneyline/horizon-league",
  "/ncaab/best-bets/moneyline/ivy-league",
  "/ncaab/best-bets/moneyline/metro-atlantic-athletic",
  "/ncaab/best-bets/moneyline/mac",
  "/ncaab/best-bets/moneyline/meac",
  "/ncaab/best-bets/moneyline/missouri-valley",
  "/ncaab/best-bets/moneyline/mountain-west",
  "/ncaab/best-bets/moneyline/northeast",
  "/ncaab/best-bets/moneyline/ohio-valley",
  "/ncaab/best-bets/moneyline/pac-12",
  "/ncaab/best-bets/moneyline/patriot-league",
  "/ncaab/best-bets/moneyline/sec",
  "/ncaab/best-bets/moneyline/southern",
  "/ncaab/best-bets/moneyline/southland",
  "/ncaab/best-bets/moneyline/southwestern-athletic",
  "/ncaab/best-bets/moneyline/summit",
  "/ncaab/best-bets/moneyline/sun-belt",
  "/ncaab/best-bets/moneyline/west-coast",
  "/ncaab/best-bets/moneyline/wac",
  "/ncaab/best-bets/totals-spread",
  "/ncaab/best-bets/totals-spread/ncaa-tournament",
  "/ncaab/best-bets/totals-spread/nit-tournament",
  "/ncaab/best-bets/totals-spread/cbi-tournament",
  "/ncaab/best-bets/totals-spread/cit-tournament",
  "/ncaab/best-bets/totals-spread/all",
  "/ncaab/best-bets/totals-spread/top-25",
  "/ncaab/best-bets/totals-spread/america-east",
  "/ncaab/best-bets/totals-spread/american",
  "/ncaab/best-bets/totals-spread/atlantic-10",
  "/ncaab/best-bets/totals-spread/atlantic-coast",
  "/ncaab/best-bets/totals-spread/atlantic-sun",
  "/ncaab/best-bets/totals-spread/big-12",
  "/ncaab/best-bets/totals-spread/big-east",
  "/ncaab/best-bets/totals-spread/big-sky",
  "/ncaab/best-bets/totals-spread/big-south",
  "/ncaab/best-bets/totals-spread/big-ten",
  "/ncaab/best-bets/totals-spread/big-west",
  "/ncaab/best-bets/totals-spread/colonial",
  "/ncaab/best-bets/totals-spread/conference-usa",
  "/ncaab/best-bets/totals-spread/horizon-league",
  "/ncaab/best-bets/totals-spread/ivy-league",
  "/ncaab/best-bets/totals-spread/metro-atlantic-athletic",
  "/ncaab/best-bets/totals-spread/mac",
  "/ncaab/best-bets/totals-spread/meac",
  "/ncaab/best-bets/totals-spread/missouri-valley",
  "/ncaab/best-bets/totals-spread/mountain-west",
  "/ncaab/best-bets/totals-spread/northeast",
  "/ncaab/best-bets/totals-spread/ohio-valley",
  "/ncaab/best-bets/totals-spread/pac-12",
  "/ncaab/best-bets/totals-spread/patriot-league",
  "/ncaab/best-bets/totals-spread/sec",
  "/ncaab/best-bets/totals-spread/southern",
  "/ncaab/best-bets/totals-spread/southland",
  "/ncaab/best-bets/totals-spread/southwestern-athletic",
  "/ncaab/best-bets/totals-spread/summit",
  "/ncaab/best-bets/totals-spread/sun-belt",
  "/ncaab/best-bets/totals-spread/west-coast",
  "/ncaab/best-bets/totals-spread/wac",
  "/ncaab/best-bets/first-half-lines",
  "/ncaab/best-bets/first-half-lines/ncaa-tournament",
  "/ncaab/best-bets/first-half-lines/nit-tournament",
  "/ncaab/best-bets/first-half-lines/cbi-tournament",
  "/ncaab/best-bets/first-half-lines/cit-tournament",
  "/ncaab/best-bets/first-half-lines/all",
  "/ncaab/best-bets/first-half-lines/top-25",
  "/ncaab/best-bets/first-half-lines/america-east",
  "/ncaab/best-bets/first-half-lines/american",
  "/ncaab/best-bets/first-half-lines/atlantic-10",
  "/ncaab/best-bets/first-half-lines/atlantic-coast",
  "/ncaab/best-bets/first-half-lines/atlantic-sun",
  "/ncaab/best-bets/first-half-lines/big-12",
  "/ncaab/best-bets/first-half-lines/big-east",
  "/ncaab/best-bets/first-half-lines/big-sky",
  "/ncaab/best-bets/first-half-lines/big-south",
  "/ncaab/best-bets/first-half-lines/big-ten",
  "/ncaab/best-bets/first-half-lines/big-west",
  "/ncaab/best-bets/first-half-lines/colonial",
  "/ncaab/best-bets/first-half-lines/conference-usa",
  "/ncaab/best-bets/first-half-lines/horizon-league",
  "/ncaab/best-bets/first-half-lines/ivy-league",
  "/ncaab/best-bets/first-half-lines/metro-atlantic-athletic",
  "/ncaab/best-bets/first-half-lines/mac",
  "/ncaab/best-bets/first-half-lines/meac",
  "/ncaab/best-bets/first-half-lines/missouri-valley",
  "/ncaab/best-bets/first-half-lines/mountain-west",
  "/ncaab/best-bets/first-half-lines/northeast",
  "/ncaab/best-bets/first-half-lines/ohio-valley",
  "/ncaab/best-bets/first-half-lines/pac-12",
  "/ncaab/best-bets/first-half-lines/patriot-league",
  "/ncaab/best-bets/first-half-lines/sec",
  "/ncaab/best-bets/first-half-lines/southern",
  "/ncaab/best-bets/first-half-lines/southland",
  "/ncaab/best-bets/first-half-lines/southwestern-athletic",
  "/ncaab/best-bets/first-half-lines/summit",
  "/ncaab/best-bets/first-half-lines/sun-belt",
  "/ncaab/best-bets/first-half-lines/west-coast",
  "/ncaab/best-bets/first-half-lines/wac",
  "/ncaab/best-bets/first-half-moneyline",
  "/ncaab/best-bets/first-half-moneyline/ncaa-tournament",
  "/ncaab/best-bets/first-half-moneyline/nit-tournament",
  "/ncaab/best-bets/first-half-moneyline/cbi-tournament",
  "/ncaab/best-bets/first-half-moneyline/cit-tournament",
  "/ncaab/best-bets/first-half-moneyline/all",
  "/ncaab/best-bets/first-half-moneyline/top-25",
  "/ncaab/best-bets/first-half-moneyline/america-east",
  "/ncaab/best-bets/first-half-moneyline/american",
  "/ncaab/best-bets/first-half-moneyline/atlantic-10",
  "/ncaab/best-bets/first-half-moneyline/atlantic-coast",
  "/ncaab/best-bets/first-half-moneyline/atlantic-sun",
  "/ncaab/best-bets/first-half-moneyline/big-12",
  "/ncaab/best-bets/first-half-moneyline/big-east",
  "/ncaab/best-bets/first-half-moneyline/big-sky",
  "/ncaab/best-bets/first-half-moneyline/big-south",
  "/ncaab/best-bets/first-half-moneyline/big-ten",
  "/ncaab/best-bets/first-half-moneyline/big-west",
  "/ncaab/best-bets/first-half-moneyline/colonial",
  "/ncaab/best-bets/first-half-moneyline/conference-usa",
  "/ncaab/best-bets/first-half-moneyline/horizon-league",
  "/ncaab/best-bets/first-half-moneyline/ivy-league",
  "/ncaab/best-bets/first-half-moneyline/metro-atlantic-athletic",
  "/ncaab/best-bets/first-half-moneyline/mac",
  "/ncaab/best-bets/first-half-moneyline/meac",
  "/ncaab/best-bets/first-half-moneyline/missouri-valley",
  "/ncaab/best-bets/first-half-moneyline/mountain-west",
  "/ncaab/best-bets/first-half-moneyline/northeast",
  "/ncaab/best-bets/first-half-moneyline/ohio-valley",
  "/ncaab/best-bets/first-half-moneyline/pac-12",
  "/ncaab/best-bets/first-half-moneyline/patriot-league",
  "/ncaab/best-bets/first-half-moneyline/sec",
  "/ncaab/best-bets/first-half-moneyline/southern",
  "/ncaab/best-bets/first-half-moneyline/southland",
  "/ncaab/best-bets/first-half-moneyline/southwestern-athletic",
  "/ncaab/best-bets/first-half-moneyline/summit",
  "/ncaab/best-bets/first-half-moneyline/sun-belt",
  "/ncaab/best-bets/first-half-moneyline/west-coast",
  "/ncaab/best-bets/first-half-moneyline/wac",
  "/ncaab/best-bets/first-half-totals-spread",
  "/ncaab/best-bets/first-half-totals-spread/ncaa-tournament",
  "/ncaab/best-bets/first-half-totals-spread/nit-tournament",
  "/ncaab/best-bets/first-half-totals-spread/cbi-tournament",
  "/ncaab/best-bets/first-half-totals-spread/cit-tournament",
  "/ncaab/best-bets/first-half-totals-spread/all",
  "/ncaab/best-bets/first-half-totals-spread/top-25",
  "/ncaab/best-bets/first-half-totals-spread/america-east",
  "/ncaab/best-bets/first-half-totals-spread/american",
  "/ncaab/best-bets/first-half-totals-spread/atlantic-10",
  "/ncaab/best-bets/first-half-totals-spread/atlantic-coast",
  "/ncaab/best-bets/first-half-totals-spread/atlantic-sun",
  "/ncaab/best-bets/first-half-totals-spread/big-12",
  "/ncaab/best-bets/first-half-totals-spread/big-east",
  "/ncaab/best-bets/first-half-totals-spread/big-sky",
  "/ncaab/best-bets/first-half-totals-spread/big-south",
  "/ncaab/best-bets/first-half-totals-spread/big-ten",
  "/ncaab/best-bets/first-half-totals-spread/big-west",
  "/ncaab/best-bets/first-half-totals-spread/colonial",
  "/ncaab/best-bets/first-half-totals-spread/conference-usa",
  "/ncaab/best-bets/first-half-totals-spread/horizon-league",
  "/ncaab/best-bets/first-half-totals-spread/ivy-league",
  "/ncaab/best-bets/first-half-totals-spread/metro-atlantic-athletic",
  "/ncaab/best-bets/first-half-totals-spread/mac",
  "/ncaab/best-bets/first-half-totals-spread/meac",
  "/ncaab/best-bets/first-half-totals-spread/missouri-valley",
  "/ncaab/best-bets/first-half-totals-spread/mountain-west",
  "/ncaab/best-bets/first-half-totals-spread/northeast",
  "/ncaab/best-bets/first-half-totals-spread/ohio-valley",
  "/ncaab/best-bets/first-half-totals-spread/pac-12",
  "/ncaab/best-bets/first-half-totals-spread/patriot-league",
  "/ncaab/best-bets/first-half-totals-spread/sec",
  "/ncaab/best-bets/first-half-totals-spread/southern",
  "/ncaab/best-bets/first-half-totals-spread/southland",
  "/ncaab/best-bets/first-half-totals-spread/southwestern-athletic",
  "/ncaab/best-bets/first-half-totals-spread/summit",
  "/ncaab/best-bets/first-half-totals-spread/sun-belt",
  "/ncaab/best-bets/first-half-totals-spread/west-coast",
  "/ncaab/best-bets/first-half-totals-spread/wac",
  "/ncaab/best-bets/second-half-lines",
  "/ncaab/best-bets/second-half-lines/ncaa-tournament",
  "/ncaab/best-bets/second-half-lines/nit-tournament",
  "/ncaab/best-bets/second-half-lines/cbi-tournament",
  "/ncaab/best-bets/second-half-lines/cit-tournament",
  "/ncaab/best-bets/second-half-lines/all",
  "/ncaab/best-bets/second-half-lines/top-25",
  "/ncaab/best-bets/second-half-lines/america-east",
  "/ncaab/best-bets/second-half-lines/american",
  "/ncaab/best-bets/second-half-lines/atlantic-10",
  "/ncaab/best-bets/second-half-lines/atlantic-coast",
  "/ncaab/best-bets/second-half-lines/atlantic-sun",
  "/ncaab/best-bets/second-half-lines/big-12",
  "/ncaab/best-bets/second-half-lines/big-east",
  "/ncaab/best-bets/second-half-lines/big-sky",
  "/ncaab/best-bets/second-half-lines/big-south",
  "/ncaab/best-bets/second-half-lines/big-ten",
  "/ncaab/best-bets/second-half-lines/big-west",
  "/ncaab/best-bets/second-half-lines/colonial",
  "/ncaab/best-bets/second-half-lines/conference-usa",
  "/ncaab/best-bets/second-half-lines/horizon-league",
  "/ncaab/best-bets/second-half-lines/ivy-league",
  "/ncaab/best-bets/second-half-lines/metro-atlantic-athletic",
  "/ncaab/best-bets/second-half-lines/mac",
  "/ncaab/best-bets/second-half-lines/meac",
  "/ncaab/best-bets/second-half-lines/missouri-valley",
  "/ncaab/best-bets/second-half-lines/mountain-west",
  "/ncaab/best-bets/second-half-lines/northeast",
  "/ncaab/best-bets/second-half-lines/ohio-valley",
  "/ncaab/best-bets/second-half-lines/pac-12",
  "/ncaab/best-bets/second-half-lines/patriot-league",
  "/ncaab/best-bets/second-half-lines/sec",
  "/ncaab/best-bets/second-half-lines/southern",
  "/ncaab/best-bets/second-half-lines/southland",
  "/ncaab/best-bets/second-half-lines/southwestern-athletic",
  "/ncaab/best-bets/second-half-lines/summit",
  "/ncaab/best-bets/second-half-lines/sun-belt",
  "/ncaab/best-bets/second-half-lines/west-coast",
  "/ncaab/best-bets/second-half-lines/wac",
  "/ncaab/best-bets/second-half-moneylines",
  "/ncaab/best-bets/second-half-moneylines/ncaa-tournament",
  "/ncaab/best-bets/second-half-moneylines/nit-tournament",
  "/ncaab/best-bets/second-half-moneylines/cbi-tournament",
  "/ncaab/best-bets/second-half-moneylines/cit-tournament",
  "/ncaab/best-bets/second-half-moneylines/all",
  "/ncaab/best-bets/second-half-moneylines/top-25",
  "/ncaab/best-bets/second-half-moneylines/america-east",
  "/ncaab/best-bets/second-half-moneylines/american",
  "/ncaab/best-bets/second-half-moneylines/atlantic-10",
  "/ncaab/best-bets/second-half-moneylines/atlantic-coast",
  "/ncaab/best-bets/second-half-moneylines/atlantic-sun",
  "/ncaab/best-bets/second-half-moneylines/big-12",
  "/ncaab/best-bets/second-half-moneylines/big-east",
  "/ncaab/best-bets/second-half-moneylines/big-sky",
  "/ncaab/best-bets/second-half-moneylines/big-south",
  "/ncaab/best-bets/second-half-moneylines/big-ten",
  "/ncaab/best-bets/second-half-moneylines/big-west",
  "/ncaab/best-bets/second-half-moneylines/colonial",
  "/ncaab/best-bets/second-half-moneylines/conference-usa",
  "/ncaab/best-bets/second-half-moneylines/horizon-league",
  "/ncaab/best-bets/second-half-moneylines/ivy-league",
  "/ncaab/best-bets/second-half-moneylines/metro-atlantic-athletic",
  "/ncaab/best-bets/second-half-moneylines/mac",
  "/ncaab/best-bets/second-half-moneylines/meac",
  "/ncaab/best-bets/second-half-moneylines/missouri-valley",
  "/ncaab/best-bets/second-half-moneylines/mountain-west",
  "/ncaab/best-bets/second-half-moneylines/northeast",
  "/ncaab/best-bets/second-half-moneylines/ohio-valley",
  "/ncaab/best-bets/second-half-moneylines/pac-12",
  "/ncaab/best-bets/second-half-moneylines/patriot-league",
  "/ncaab/best-bets/second-half-moneylines/sec",
  "/ncaab/best-bets/second-half-moneylines/southern",
  "/ncaab/best-bets/second-half-moneylines/southland",
  "/ncaab/best-bets/second-half-moneylines/southwestern-athletic",
  "/ncaab/best-bets/second-half-moneylines/summit",
  "/ncaab/best-bets/second-half-moneylines/sun-belt",
  "/ncaab/best-bets/second-half-moneylines/west-coast",
  "/ncaab/best-bets/second-half-moneylines/wac",
  "/xfl/best-bets/moneyline",
  "/xfl/best-bets/totals-spread",
  "/xfl/best-bets/first-half-lines",
  "/xfl/best-bets/first-half-moneyline",
  "/xfl/best-bets/first-half-totals-spread",
  "/xfl/best-bets/second-half-lines",
  "/xfl/best-bets/second-half-moneylines",
  "/nhl/best-bets/totals-spread",
  "/nhl/best-bets/ats-odds",
  "/nhl/best-bets/first-period-moneyline",
  "/nhl/best-bets/first-period-totals-spread",
  "/nhl/best-bets/first-period-ats-odds",
  "/nhl/best-bets/second-period-moneyline",
  "/nhl/best-bets/second-period-ats-odds",
  "/nhl/best-bets/third-period-moneyline",
  "/nhl/best-bets/third-period-ats-odds",
  "/mlb/best-bets/run-line-odds",
  "/mlb/best-bets/totals-spread",
  "/mlb/best-bets/first-five-innings-odds",
  "/mlb/best-bets/first-five-innings-totals",
  "/nfl/best-bets/moneyline",
  "/nfl/best-bets/totals-spread",
  "/nfl/best-bets/first-half-lines",
  "/nfl/best-bets/first-half-moneyline",
  "/nfl/best-bets/first-half-totals-spread",
  "/nfl/best-bets/second-half-lines",
  "/nfl/best-bets/second-half-moneylines",
  "/ncaaf/best-bets/moneyline",
  "/ncaaf/best-bets/moneyline/all",
  "/ncaaf/best-bets/moneyline/top-25",
  "/ncaaf/best-bets/moneyline/american-athletic",
  "/ncaaf/best-bets/moneyline/atlantic-coast",
  "/ncaaf/best-bets/moneyline/big-12",
  "/ncaaf/best-bets/moneyline/big-ten",
  "/ncaaf/best-bets/moneyline/conference-usa",
  "/ncaaf/best-bets/moneyline/fbs-independents",
  "/ncaaf/best-bets/moneyline/mid-american",
  "/ncaaf/best-bets/moneyline/mountain-west",
  "/ncaaf/best-bets/moneyline/pac-12",
  "/ncaaf/best-bets/moneyline/sec",
  "/ncaaf/best-bets/moneyline/sun-belt",
  "/ncaaf/best-bets/totals-spread",
  "/ncaaf/best-bets/totals-spread/all",
  "/ncaaf/best-bets/totals-spread/top-25",
  "/ncaaf/best-bets/totals-spread/american-athletic",
  "/ncaaf/best-bets/totals-spread/atlantic-coast",
  "/ncaaf/best-bets/totals-spread/big-12",
  "/ncaaf/best-bets/totals-spread/big-ten",
  "/ncaaf/best-bets/totals-spread/conference-usa",
  "/ncaaf/best-bets/totals-spread/fbs-independents",
  "/ncaaf/best-bets/totals-spread/mid-american",
  "/ncaaf/best-bets/totals-spread/mountain-west",
  "/ncaaf/best-bets/totals-spread/pac-12",
  "/ncaaf/best-bets/totals-spread/sec",
  "/ncaaf/best-bets/totals-spread/sun-belt",
  "/ncaaf/best-bets/first-half-lines",
  "/ncaaf/best-bets/first-half-lines/all",
  "/ncaaf/best-bets/first-half-lines/top-25",
  "/ncaaf/best-bets/first-half-lines/american-athletic",
  "/ncaaf/best-bets/first-half-lines/atlantic-coast",
  "/ncaaf/best-bets/first-half-lines/big-12",
  "/ncaaf/best-bets/first-half-lines/big-ten",
  "/ncaaf/best-bets/first-half-lines/conference-usa",
  "/ncaaf/best-bets/first-half-lines/fbs-independents",
  "/ncaaf/best-bets/first-half-lines/mid-american",
  "/ncaaf/best-bets/first-half-lines/mountain-west",
  "/ncaaf/best-bets/first-half-lines/pac-12",
  "/ncaaf/best-bets/first-half-lines/sec",
  "/ncaaf/best-bets/first-half-lines/sun-belt",
  "/ncaaf/best-bets/first-half-moneyline",
  "/ncaaf/best-bets/first-half-moneyline/all",
  "/ncaaf/best-bets/first-half-moneyline/top-25",
  "/ncaaf/best-bets/first-half-moneyline/american-athletic",
  "/ncaaf/best-bets/first-half-moneyline/atlantic-coast",
  "/ncaaf/best-bets/first-half-moneyline/big-12",
  "/ncaaf/best-bets/first-half-moneyline/big-ten",
  "/ncaaf/best-bets/first-half-moneyline/conference-usa",
  "/ncaaf/best-bets/first-half-moneyline/fbs-independents",
  "/ncaaf/best-bets/first-half-moneyline/mid-american",
  "/ncaaf/best-bets/first-half-moneyline/mountain-west",
  "/ncaaf/best-bets/first-half-moneyline/pac-12",
  "/ncaaf/best-bets/first-half-moneyline/sec",
  "/ncaaf/best-bets/first-half-moneyline/sun-belt",
  "/ncaaf/best-bets/first-half-totals-spread",
  "/ncaaf/best-bets/first-half-totals-spread/all",
  "/ncaaf/best-bets/first-half-totals-spread/top-25",
  "/ncaaf/best-bets/first-half-totals-spread/american-athletic",
  "/ncaaf/best-bets/first-half-totals-spread/atlantic-coast",
  "/ncaaf/best-bets/first-half-totals-spread/big-12",
  "/ncaaf/best-bets/first-half-totals-spread/big-ten",
  "/ncaaf/best-bets/first-half-totals-spread/conference-usa",
  "/ncaaf/best-bets/first-half-totals-spread/fbs-independents",
  "/ncaaf/best-bets/first-half-totals-spread/mid-american",
  "/ncaaf/best-bets/first-half-totals-spread/mountain-west",
  "/ncaaf/best-bets/first-half-totals-spread/pac-12",
  "/ncaaf/best-bets/first-half-totals-spread/sec",
  "/ncaaf/best-bets/first-half-totals-spread/sun-belt",
  "/ncaaf/best-bets/second-half-lines",
  "/ncaaf/best-bets/second-half-lines/all",
  "/ncaaf/best-bets/second-half-lines/top-25",
  "/ncaaf/best-bets/second-half-lines/american-athletic",
  "/ncaaf/best-bets/second-half-lines/atlantic-coast",
  "/ncaaf/best-bets/second-half-lines/big-12",
  "/ncaaf/best-bets/second-half-lines/big-ten",
  "/ncaaf/best-bets/second-half-lines/conference-usa",
  "/ncaaf/best-bets/second-half-lines/fbs-independents",
  "/ncaaf/best-bets/second-half-lines/mid-american",
  "/ncaaf/best-bets/second-half-lines/mountain-west",
  "/ncaaf/best-bets/second-half-lines/pac-12",
  "/ncaaf/best-bets/second-half-lines/sec",
  "/ncaaf/best-bets/second-half-lines/sun-belt",
  "/ncaaf/best-bets/second-half-moneylines",
  "/ncaaf/best-bets/second-half-moneylines/all",
  "/ncaaf/best-bets/second-half-moneylines/top-25",
  "/ncaaf/best-bets/second-half-moneylines/american-athletic",
  "/ncaaf/best-bets/second-half-moneylines/atlantic-coast",
  "/ncaaf/best-bets/second-half-moneylines/big-12",
  "/ncaaf/best-bets/second-half-moneylines/big-ten",
  "/ncaaf/best-bets/second-half-moneylines/conference-usa",
  "/ncaaf/best-bets/second-half-moneylines/fbs-independents",
  "/ncaaf/best-bets/second-half-moneylines/mid-american",
  "/ncaaf/best-bets/second-half-moneylines/mountain-west",
  "/ncaaf/best-bets/second-half-moneylines/pac-12",
  "/ncaaf/best-bets/second-half-moneylines/sec",
  "/ncaaf/best-bets/second-half-moneylines/sun-belt",
  "/premier-league/best-bets/over-unders",
  "/premier-league/best-bets/spread",
  "/premier-league/best-bets/first-half-moneyline",
  "/premier-league/best-bets/first-half-lines",
  "/premier-league/best-bets/second-half-moneyline",
  "/premier-league/best-bets/second-half-line",
  "/bundesliga/best-bets/over-unders",
  "/bundesliga/best-bets/spread",
  "/bundesliga/best-bets/first-half-moneyline",
  "/bundesliga/best-bets/first-half-lines",
  "/bundesliga/best-bets/second-half-moneyline",
  "/bundesliga/best-bets/second-half-line",
  "/mls/best-bets/over-unders",
  "/mls/best-bets/spread",
  "/mls/best-bets/first-half-moneyline",
  "/mls/best-bets/first-half-lines",
  "/mls/best-bets/second-half-moneyline",
  "/mls/best-bets/second-half-line",
  "/la-liga/best-bets/over-unders",
  "/la-liga/best-bets/spread",
  "/la-liga/best-bets/first-half-moneyline",
  "/la-liga/best-bets/first-half-lines",
  "/la-liga/best-bets/second-half-moneyline",
  "/la-liga/best-bets/second-half-line",
  "/serie-a/best-bets/over-unders",
  "/serie-a/best-bets/spread",
  "/serie-a/best-bets/first-half-moneyline",
  "/serie-a/best-bets/first-half-lines",
  "/serie-a/best-bets/second-half-moneyline",
  "/serie-a/best-bets/second-half-line",
  "/champions-league/best-bets/over-unders",
  "/champions-league/best-bets/spread",
  "/champions-league/best-bets/first-half-moneyline",
  "/champions-league/best-bets/first-half-lines",
  "/champions-league/best-bets/second-half-moneyline",
  "/champions-league/best-bets/second-half-line",
  "/atp/best-bets/ats-odds",
  "/atp/best-bets/over-unders",
  "/wta/best-bets/ats-odds",
  "/wta/best-bets/over-unders",
  "/golf/best-bets/ats-odds",
  "/golf/best-bets/over-unders",
];

export const isPpcPage = (pathname?: string): boolean => {
  if (!pathname) {
    return false;
  }
  return pathname.endsWith("ppc");
};
